import React from "react";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TelegramIcon from "@mui/icons-material/Telegram";
import InstagramIcon from "@mui/icons-material/Instagram";
import { useNavigate } from "react-router-dom";

export default function InflueCard() {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => {
        navigate("/influencer/info");
      }}
      className=" cursor-pointer bg-slate-100 dark:bg-slate-900/60 rounded-xl border-[0.5px] dark:border-amber-50 border-slate-500 flex flex-col items-center p-2"
    >
      <div className="h-24 w-24 rounded-full mt-2">
        <img
          className="rounded-full object-cover w-full h-full"
          src="https://images.pexels.com/photos/37270614/pexels-photo-37270614.jpeg"
          alt=""
        />
      </div>
      <span className="text-lg mt-2 font-semibold text-slate-600 dark:text-slate-200">
        Moon Moon
      </span>
      <span className="text-md text-slate-500 dark:text-slate-400">
        Delhi,India
      </span>
      <div className="grid grid-cols-3 gap-3 mt-6  text-xs font-semibold font-sans text-slate-600 dark:text-slate-300 border-slate-300  items-center justify-center">
        <span className=" px-2 py-1 bg-slate-700/20 border   rounded-md ">
          Gaming
        </span>
        <span className=" px-2 py-1 bg-slate-700/20 border  rounded-md ">
          Earning
        </span>
        <span className=" px-2 py-1 bg-slate-700/20 border  rounded-md ">
          Offers
        </span>
      </div>
      <div className="border-b-1 mt-4 w-full border-slate-400" />
      <div className="flex  items-center justify-between gap-2 mt-2">
        <div className="flex items-center justify-center space-x-1">
          <YouTubeIcon className="text-red-500 w-20 h-20" />
          <span className="text-slate-700 dark:text-slate-300 text-sm">
            10K
          </span>
        </div>
        <div className="flex items-center justify-center border-l border-r border-slate-400 px-4">
          <TelegramIcon className="text-blue-500 w-20 h-20" />
          <span className="text-slate-700 dark:text-slate-300 text-sm">
            100K
          </span>
        </div>
        <div className="flex items-center justify-center space-x-1">
          <InstagramIcon className="text-orange-500 w-20 h-20" />
          <span className="text-slate-700 dark:text-slate-300 text-sm">
            10K
          </span>
        </div>
      </div>
    </div>
  );
}
